import qs from 'qs'
export default (api) => {
  api.photo = {
    public: {
    },
    memberConsole: {
      upload: (formData, onProgress = null, meta = {}) => {
        if(api._isGif(formData)) meta.config.keepOrigin = true
        let params = {
          ...meta,
        }
        const query = _isEmpty(params) ? '' : `?${qs.stringify(params, { arrayFormat: 'indices' })}`

        return api.request({
          url: `/api/member-console/photo/upload${query}`,
          type: 'post',
          data: formData,
          martipart: true,
          onUploadProgress: onProgress,
        })
      },
    },
    admin: {
      index: (params = null) => api.request({
        url: `/api/admin/photo/index`,
        type: 'get',
        params: {
          ...params,
          sort: {
            created_at: 'desc',
          },
        },
      }),
      createExternal: (params) => api.request({
        url: `/api/admin/photo/external`,
        type: 'post',
        params,
      }),
      upload: (formData, onProgress = null, meta = {}) => {
        if(api._isGif(formData)) meta.config.keepOrigin = true
        let params = {
          ...meta,
        }
        const query = _isEmpty(params) ? '' : `?${qs.stringify(params, { arrayFormat: 'indices' })}`

        return api.request({
          url: `/api/admin/photo/upload${query}`,
          type: 'post',
          data: formData,
          martipart: true,
          onUploadProgress: onProgress,
        })
      },
      batchDelete: (params) => api.request({
        url: `/api/admin/photo/batch`,
        type: 'delete',
        params,
      }),
    },
  }
}